import type { Category } from "@/constants/categories";

type CookingOilProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  spray:
    "https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
  image: string,
): CookingOilProduct => ({
  id,
  name,
  categorySlug: "cooking-oils",
  brand,
  unit,
  price,
  image,
});

export const COOKING_OIL_PRODUCTS: CookingOilProduct[] = [
  item("oil-pam-butter", "PAM Butter Cooking Spray", "PAM", "141g", 7.99, IMG.spray),
  item("oil-pam-olive", "PAM Olive Oil Cooking Spray", "PAM", "141g", 7.99, IMG.spray),
  item("oil-pam-original", "PAM Original Cooking Spray", "PAM", "141g", 7.99, IMG.spray),
];

